import React from 'react';
import useStyles from './Login.styles';
import { useDispatch, useSelector } from 'react-redux';
import { Button, CircularProgress } from '@material-ui/core';
import { login, selectIsLoading, selectLoginError, selectMfaRequired, cancelLogin, sendMFACode } from '../../state';
import Avatar from '@material-ui/core/Avatar';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import { TextField, makeValidate, makeRequired } from 'mui-rff';
import { Form } from 'react-final-form';
import * as Yup from 'yup';
import PromptMfaCode from '../../components/PromptMfaCode';

const schema = Yup.object().shape({
  email: Yup.string().email().required(),
  password: Yup.string().required(),
});

const validate = makeValidate(schema);

const required = makeRequired(schema);

export default function LabeResultsList() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const loading = useSelector(selectIsLoading);
  const loginError = useSelector(selectLoginError);
  const mfaRequired = useSelector(selectMfaRequired);

  function onSubmit(values: {email: string, password: string}) {
    const {email, password} = values;
    dispatch(login(email, password));
  }

  return (
    <Container component="main" maxWidth="xs">
      <div className={classes.paper}>
        <Avatar className={classes.avatar}>
          <LockOutlinedIcon />
        </Avatar>
        <Typography component="h1" variant="h5">
          Sign in
        </Typography>
        <Form
          onSubmit={onSubmit}
          initialValues={{}}
          subscription={{}}
          validate={validate as any}
          render={({ handleSubmit }: {handleSubmit: any}) => (
            <form className={classes.form} noValidate>
              <TextField
                variant="outlined"
                margin="normal"
                required={required.email}
                fullWidth
                id="email"
                label="Email Address"
                name="email"
                autoComplete="email"
                autoFocus
              />
              <TextField
                variant="outlined"
                margin="normal"
                required={required.password}
                fullWidth
                name="password"
                label="Password"
                type="password"
                id="password"
                autoComplete="current-password"
              />
              <div className={classes.wrapper}>
                <Button
                  type="submit"
                  fullWidth
                  variant="contained"
                  color="primary"
                  onClick={handleSubmit}
                  disabled={loading}
                  className={classes.submit}
                >
                  Sign In
                </Button>
                {loading && <CircularProgress size={24} className={classes.buttonProgress} />}
              </div>
              { loginError ? (
                <div className={classes.errorMessage}>{loginError}</div>
              ) : null}
              <PromptMfaCode
                open={mfaRequired}
                onClose={() => dispatch(cancelLogin())}
                onConfirm={(code: string) => dispatch(sendMFACode(code))}
              />
            </form>
          )} />
      </div>
    </Container>
  );
}